/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
}

const InstancesSlice = createAppSlice({
    name: 'supervision/instances',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createInstance: create.asyncThunk(
            async (instance, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.instance.all(), { body: instance, method: 'POST' })
                    toast.success('Instance créé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'une instance')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        updateInstance: create.asyncThunk(
            async (instance, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.instance.all(), { body: instance, method: 'PUT' })
                    toast.success('Instance modifié avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'une instance')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        deleteInstance: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.instance.single(id), { method: 'DELETE' })
                    toast.success('Instance supprimé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'une instance')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetchInstances: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.instance.all())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des instances')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const byId = keyBy(action.payload, 'id')
                    state.byId = byId
                    state.allIds = action.payload.map(instance => instance.id)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { supervision } = getState()
                        return supervision.instances.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),
    }),
    selectors: {
        selectInstances: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const { fetchInstances, createInstance, updateInstance, deleteInstance } = InstancesSlice.actions
export const InstancesActions = InstancesSlice.actions
export const {
    selectInstances,
} = InstancesSlice.getSelectors((state) => state.supervision.instances)
export default InstancesSlice